import { combineReducers } from 'redux';

const initialState = {
    userList:undefined,
    userListCount:0,
    userCreated:false,
    userExists:undefined,
    showUserForm : false,
    newUser      : false,
    editProfile: false,
    currentUser:undefined,
    profileUpdated :false,
    searchIndex : false,
    searchSelectduser : false,
    userchanged: true,
    searchEmail : [],
    pswdUpdated:true
};


const userListData = (state = initialState, action) => {
    switch(action.type){
        case "USER_DATA_SUCCESS":
            return {
                ...state,
                userList  : (action.userData&& action.userData.data? (action.userData.data.response) : state.userList),
                userListCount : (action.userData&& action.userData.data&& action.userData.data.response) ? action.userData.data.response.length : state.userListCount,
            }
        case "USER_DATA_SEARCH_SUCCESS":
            return {
                ...state,
                filteredData : action.filteredData ? action.filteredData:state.filteredData,
                userListCount :  action.filteredData ? action.filteredData.length :state.userListCount,
                searchText : action.searchText?action.searchText:'',
                userid : action.userid?'1':'',
                sort : action.sort?action.sort : 'new'

            }
        case "CREATE_USER":
            return {
                ...state,
                userCreated  : !state.userCreated,

            }
        case "PASSWORD_UPDATE":
            return {
                ...state,
                pswdUpdated  : !state.pswdUpdated,

            }
        case "EXIST_USER_EMAIL":
            return {
                ...state,
                userExists  : (action.userExists && action.userExists.data? (action.userExists.data.response) : undefined),
            }
        case "SHOW_USER_MODAL":
            return {
                ...state,
                showUserForm  : !state.showUserForm,
            }
        case "NEW_USER":
            return {
                ...state,
                newUser  : true,
                userid : undefined,
                userIndex : '-1'
            }
        case "EDIT_PROFILE":
            return {
                ...state,
                editProfile:!state.editProfile,
            }
        case "EDIT_USER":
            return {
                ...state,
                newUser  : false,
                userIndex : action.userIndex
            }
        case "GET_USER":
            return {
                ...state,
                currentUser : action.currentUser ? action.currentUser.data.response:state.currentUser,
            }
        case "UPDATE_USER_PROFILE":
            return {
                ...state,
                profileUpdated  : !state.profileUpdated,

            }
        case "UPDATE_SEARCHINDEX":
            return {
                ...state,
                searchIndex  : true

            }
        case "UPDATE_INDEX":
            return {
                ...state,
                userIndex : '-1'

            }
        case "SELECTED_USER":
            return {
                ...state,
                searchSelectduser : action.selecteduser ?  action.selecteduser.data.response : state.searchSelectduser,

            }
        case "EXIST_EMAIL":
            console.log(action);
            return {
                ...state,
                searchEmail  : action.emailExists ? action.emailExists.data.response : [],

            }

        default:
            return state;
    }
}


const user = combineReducers({
    userListData
})

export default user;
//export const getUserData = state => state.user.userListData;


// WEBPACK FOOTER //
// ./src/reducers/user.js